module.exports = "../../../../platform/assets/pageMainIcon/cd-date-period.svg";